import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {Sticker, stickerCtl as ctl} from '@extensions/sticker/sticker'
import {ImportFromFileStore} from '../import-from-file-store'

const stickerStartWith = 'Sticker '

// TODO! Check usage of this func
export const getCustomStickers = (
  row: Record<string, string>,
  store: ImportFromFileStore,
  processedColumns: string[],
  board: Hub
): Record<DataObjectId, string> => {
  const {stickerNamesMap} = store

  const rowStickerNames = Object.keys(row)
    .filter(el => el.includes(stickerStartWith))
    .map(key => key.slice(stickerStartWith.length))
    .filter(Boolean)

  const box = Sync.getCurrentSandbox()
  const outputStickers: {[key: DataObjectId]: string} = {}

  for (const rowStickerName of rowStickerNames) {
    processedColumns.push(`Sticker ${rowStickerName}`)

    const stickerName = stickerNamesMap[rowStickerName] ?? rowStickerName

    let foundSt = Sticker.getByName(box, stickerName)
    if (foundSt && foundSt.properties?.stickerType !== 'string') {
      foundSt = Sticker.getByName(box, `${stickerName} (2)`)
    }

    const stickerTag = foundSt ?? Sticker.create(box, stickerName, 'string')
    if (stickerTag?.title !== stickerName) {
      stickerNamesMap[stickerName] = stickerTag?.title || ''
    }

    if (stickerTag && !Sticker.isInBoard(board, stickerTag)) {
      Sticker.addToBoard(board, stickerTag)
    }

    const rowStickerStateName = row[stickerStartWith + rowStickerName]
    const stickerStates = stickerTag ? ctl.String.listStates(stickerTag) : []

    const foundState = stickerStates.find(st => st.name === rowStickerStateName)

    if (foundState && stickerTag) {
      outputStickers[stickerTag.id] = foundState.id
    } else {
      const id = ctl.String.makeShortId()
      const name = rowStickerStateName
      const color = 'sticker-gray'
      if (stickerTag) {
        ctl.String.addState(stickerTag, {name, id, color})
        outputStickers[stickerTag.id] = id
      }
    }
  }

  return outputStickers
}
